import { Button, useTheme } from '@archipro-design/aria';
import { Tag as TagIcon } from '@archipro-design/icons';

interface TagMarkerProps {
    isApproved: boolean;
}

const TagMarker = ({ isApproved }: TagMarkerProps) => {
    const theme = useTheme();

    const buttonBackgroundColor = isApproved
        ? theme.siteVariables.colors.gold['000']
        : theme.siteVariables.colors.danger[200];

    return (
        <Button
            size={20}
            variables={{
                buttonPadding: 12,
                iconPadding: 0,
                buttonRadius: '50%',
                primaryButtonBackgroundColorNormal: buttonBackgroundColor,
                primaryButtonBackgroundColorHover: buttonBackgroundColor,
            }}
            icon={
                <TagIcon
                    color={theme.siteVariables.naturalColors.white['FFF']}
                />
            }
            styles={{
                zIndex: theme.siteVariables.zIndexes.foreground,
            }}
        />
    );
};

export default TagMarker;
